var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-logo"},[_vm._v(" PASS on Point "),_c('Loader',{attrs:{"loading":"","errorMessage":"The account could not be loaded. Please try again at a later moment"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }